<template>
  <base-list
    key="viewedTab"
    :page-size="pageSize"
    :items="viewedItems"
    :count="count"
    :loading="loading"
    mode="loadMore"
    show-load-more
    @load-more="onLoadMore"
    @reached-bottom="onLoadMore"
  >
    <template #loading>
      <base-skeleton
        v-for="n in 3"
        :key="n"
        :opacity="0 + (1 /n)"
      >
        <div class="d-flex justify-content-between mb-2">
          <div class="w-100">
            <div
              class="skeleton__item"
              style="max-width: 200px"
            />
            <div
              class="skeleton__item"
              style="max-width: 120px"
            />
          </div>
          <div
            class="skeleton__item mt-0 ml-2"
            style="max-width: 40px"
          />
        </div>
        <div class="d-flex">
          <div
            v-for="s in 3"
            :key="s"
            class="skeleton__item mr-2 mt-2"
            style="width: 120px; height: 120px"
          />
        </div>
      </base-skeleton>
    </template>
    <template #nodata>
      <empty
        :align="115"
        title="No product views yet"
        subtitle="Create an edit to start emailing your clients"
      />
    </template>
    <template #default="{item}">
      <activity-cell
        :client-full-name="item.first_name || item.last_name ? `${item.first_name} ${item.last_name}` : item.external_id"
        :item-id="item.pk"
        :date="null"
        :email="item.email"
        :items="item.views"
        :last-update="item.last_update"
        date-verb="Viewed"
        :show-size="false"
      />
    </template>
  </base-list>
</template>
<script>
import Listable from '@/components/mixins/listable';
import ActivityCell from './ActivityCell';

export default {
  name: 'ViewsList',
  components: {
    ActivityCell,
  },
  mixins: [Listable],
  props: {
    source: {
      type: String,
      default: 'customerViews',
    },
    mode: {
      type: String,
      default: 'loadMore',
    },
  },
  data() {
    return {
      queryParams: {
        // TODO: Maybe we can get rid of this param? Discuss - [says maxito in 909922fff]
        outreach__sender__pk: this.userId,
        scope: 'manager',
      },
    };
  },
  computed: {
    /** Returns elements grouped by customer, sorted by newest interaction. */
    viewedItems() {
      return (this.elements ?? []).map((el) => ({
        ...el,
        views: el.views.map((p) => ({ date: p.date, site_url: p.url, ...p.product })),
      }));
    },
    userId() {
      return this.$store.state.account.user.profile.pk;
    },
    count() {
      return this.$store.state.customerViews.count;
    },
  },
  methods: {
    onLoadMore() {
      this.loadMore();
    },
  },
};
</script>
